import { Box, Card, Chip, Link, Typography, useTheme } from '@mui/material';
import { type IRelease } from '../Interfaces/IChangelog';
import { ShadowContent } from '../core/ShadowContent';

export const ReleaseCard = ({ release }: { release: IRelease }) => {
  const theme = useTheme();

  return (
    <Card
      variant='outlined'
      key={`release-${release.id}`}
      sx={{
        p: 4,
        borderRadius: 2,
        backgroundColor: theme.palette.grey[50],
      }}
      id={`release-${release.id}`}
    >
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Typography variant='h5' component='h2'>
            {release.title}
          </Typography>
          <Chip
            variant='outlined'
            size='small'
            color='primary'
            label={`Veröffentlicht am: ${new Date(release.releaseAt).toLocaleDateString()}`}
          />
        </Box>
        <Box>
          <div dangerouslySetInnerHTML={{ __html: release.descriptionHtml }} />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          mt: 4,
        }}
      >
        {release.changes.map(change => (
          <Box
            key={change.id}
            sx={{
              backgroundColor: theme.palette.grey[100],
              p: 3,
              borderRadius: 4,
              border: `1px solid ${theme.palette.grey[200]}`,
            }}
          >
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Typography variant='h6' component='h3'>
                {change.title}
                {change.isHighlighted && ' ⭐'}
              </Typography>
              <Chip variant='outlined' size='small' label={change.changeType} />
            </Box>
            <>
              <ShadowContent html={change.descriptionHtml} />
            </>
            {change.dinoAcademyLink && (
              <Link
                sx={{ mt: 2 }}
                href={change.dinoAcademyLink}
                target='_blank'
                rel='noopener noreferrer'
              >
                Learn more
              </Link>
            )}
          </Box>
        ))}
      </Box>
    </Card>
  );
};
